import React from 'react';
import styles from './CartOrderItem.scss';
import { CurrencyUtils } from '@wix/wixrest-utils';
import Quantity from '../Quantity/Quantity';
import { createCartOrderItem } from '../../utils/DishUtils';
import { object, string, func, number } from 'prop-types';
import { translate } from 'react-i18next';
import { createI18nObject } from '../../utils/i18nUtils';
import { Text } from 'wix-style-react';

function CartOrderItem({ orderItem, itemsHash, locale, currency, cartIndex, onIncrease, onDecrease, onClick, t }) {
  const { fullOrderItem, choicesStr } = createCartOrderItem({
    orderItem,
    itemsHash,
    i18n: createI18nObject(t),
    locale,
    currency,
  });
  const displayPrice = fullOrderItem.totalPrice > 0;

  return (
    <div className={styles.wrapper} onClick={() => onClick({ cartIndex })} data-hook="cart-item">
      <div className={styles.middleWrapper}>
        <div className={styles.innerWrapper}>
          <Quantity
            allowDelete
            small
            min={1}
            value={fullOrderItem.count}
            onUpClick={e => {
              e.stopPropagation();
              onIncrease({ cartIndex, previousCount: fullOrderItem.count, count: fullOrderItem.count + 1 });
            }}
            onDownClick={e => {
              e.stopPropagation();
              onDecrease({ cartIndex, previousCount: fullOrderItem.count, count: fullOrderItem.count - 1 });
            }}
            onDelete={e => {
              e.stopPropagation();
              onDecrease({ cartIndex, previousCount: fullOrderItem.count, count: 0 });
            }}
          />
          <div className={styles.details}>
            <Text size="medium" weight="normal" tagName="div" data-hook="cart-order-item-title">
              {fullOrderItem.title[locale]}
            </Text>
            {choicesStr && (
              <Text
                size="small"
                weight="normal"
                secondary
                tagName="div"
                data-hook="cart-order-item-choices"
                className={styles.itemOptions}
              >
                {choicesStr}
              </Text>
            )}
          </div>
          <Text size="medium" weight="normal" className={styles.price} data-hook="cart-order-item-price">
            {displayPrice && CurrencyUtils.toStr(fullOrderItem.totalPrice / 100, currency, locale)}
          </Text>
        </div>
        {fullOrderItem.specialRequest && (
          <div className={styles.itemSpecialRequestWrapper}>
            <Quantity value={fullOrderItem.count} small className={styles.hidden} />
            <div className={styles.itemSpecialRequest}>
              <Text size="small" weight="normal" secondary data-hook="cart-order-item-special-request">
                {fullOrderItem.specialRequest}
              </Text>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

CartOrderItem.propTypes = {
  orderItem: object,
  itemsHash: object,
  t: func,
  locale: string,
  currency: string,
  onIncrease: func,
  onDecrease: func,
  cartIndex: number,
  onClick: func,
};

CartOrderItem.defaultProps = {
  onClick: () => null,
};

export default translate()(CartOrderItem);
